import { useState, useEffect, useContext } from "react";
import TransactionsTable from "./TransactionsTable";
import BarChart from "./BarChart";
import RefreshContext from "../RefreshContext";

import EditPayee from "./EditPayee";
import Dollars from "./Dollars";
import apiClient from "../lib/apiClient";

export default function Search() {
  const [results, setResults] = useState(null);
  const [payee, setPayee] = useState(null);
  const [query, setQuery] = useState(null);

  const { refreshKey } = useContext(RefreshContext);
  const params = new URLSearchParams(window.location.search);
  const q = params.get("q");

  useEffect(() => {
    if (q.length > 2) {

      setQuery(q);
      apiClient.get(`/api/search?q=${q}`)
        .then(({ data }) => setResults(data))
        .catch(console.error);

    }
  }, [q, refreshKey]);


  if (!results) return ""
  const { transactions, payees } = results;
  const isEmpty = transactions?.length === 0 && payees?.length === 0;

  return (
    <div className="col-12 p-3 pt-5">
      <h2>
        <i className="bi bi-search me-2" />
        {query}
      </h2>
      <hr />
      <div className="row">
        {isEmpty && <div className="col-12">
          <h3>No results found</h3>
          <p>Try searching for something else or increasing your time range.</p>
        </div>}

        <div className="col-8">
          {transactions && transactions.length > 0 && <div className="d-flex flex-column">
            <h3>Transactions</h3>
            <hr />
            <TransactionsTable transactions={transactions} />
          </div>}
        </div>
        {payees && payees.length > 0 && <div className="col-4">
          <h3>Payees</h3>
          <hr />
          <div className="mt-3 d-flex flex-column">
            {payees.map((payee, i) => (
              <PayeeItem key={i} payee={payee} setPayee={setPayee} />
            ))}
          </div>
        </div>}


        {payee && <EditPayee
          refreshKey={refreshKey}
          payee={payee}
          onHide={() => setPayee(null)} />}
      </div>
    </div>
  );
}

function PayeeItem({ payee, setPayee, refreshKey }) {
  const { name, category, chart_data } = payee;
  return (
    <div className="p-2">
      <div className="card">
        <div className="card-header d-flex align-items-baseline">
          <h4>{name}</h4>
          <h6 className="flex-grow-1 ms-2">{category}</h6>
          <button className="btn btn-link float-end"
            onClick={() => setPayee(payee)}>
            Edit
          </button>
        </div>
        <div className="card-body">
          <BarChart data={chart_data} height={200} />
        </div>
        <div className="card-footer justify-content-end d-flex">
          Total: <Dollars amount={payee.total} />
        </div>
      </div>
    </div>
  );

}